<template>
	<div class="four-column-banner">
		<div class="mobile-mode">
			<div class="col-12 py-2 px-0">
				<a v-if="config.first_mobile_image_url" :href="config.first_url"><img :src="config.first_mobile_image_url" class="d-block w-100" alt="slide"></a>
				<a v-else :href="config.first_url"><img :src="config.first_image_url" class="d-block w-100" alt="slide"></a>
			</div>
			<div class="col-12 py-2 px-0">
				<a v-if="config.second_mobile_image_url" :href="config.second_url"><img :src="config.second_mobile_image_url" class="d-block w-100" alt="slide"></a>
				<a v-else :href="config.second_url"><img :src="config.second_image_url" class="d-block w-100" alt="slide"></a>
			</div>
			<div class="col-12 py-2 px-0">
				<a v-if="config.third_mobile_image_url" :href="config.third_url"><img :src="config.third_mobile_image_url" class="d-block w-100" alt="slide"></a>
				<a v-else :href="config.third_url"><img :src="config.third_image_url" class="d-block w-100" alt="slide"></a>
			</div>
			<div class="col-12 py-2 px-0">
				<a v-if="config.fourth_mobile_image_url" :href="config.fourth_url"><img :src="config.fourth_mobile_image_url" class="d-block w-100" alt="slide"></a>
				<a v-else :href="config.fourth_url"><img :src="config.fourth_image_url" class="d-block w-100" alt="slide"></a>
			</div>
		</div>
		<div class="desktop-mode">
			<div class="row">
				<div class="col-12 col-lg-3">
					<a :href="config.first_url"><img :src="config.first_image_url" class="d-block w-100" alt="slide"></a>
				</div>
				<div class="col-12 col-lg-3">
					<a :href="config.second_url"><img :src="config.second_image_url" class="d-block w-100" alt="slide"></a>
				</div>
				<div class="col-12 col-lg-3">
					<a :href="config.third_url"><img :src="config.third_image_url" class="d-block w-100" alt="slide"></a>
				</div>
				<div class="col-12 col-lg-3">
					<a :href="config.fourth_url"><img :src="config.fourth_image_url" class="d-block w-100" alt="slide"></a>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Banner',
	props: {
		config: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
		};
	},
};
</script>
<style lang="scss" scoped>
	.four-column-banner {
		img {
			border-radius: 5px;
		}
	}
	.desktop-mode {
		display: block;
	}

	@media only screen and (max-width: 767px) {
		.desktop-mode {
			display: none;
		}
	}
	@media only screen and (min-width: 768px) {
		.mobile-mode {
			display: none;
		}
	}
</style>
